import classNames from 'classnames';
import type { CSSProperties } from 'react';
import { useCallback } from 'react';

import List from '@/icon/List';
import X from '@/icon/X';
import { useFloating } from '@floating-ui/react';
import type { NavbarMenuBurgerElementProps } from '../../navbarElement/Navbar.type';
import { computeColor } from '../../utils/colors';
import * as styles from '../Navbar.css';
import { NAVBAR_MENU_BURGER_DEFAULTS_V2 } from './NavbarMenuBurger.constants';
import * as v2Styles from './NavbarMenuBurger.css';

export function NavbarMenuBurgerV2(props: NavbarMenuBurgerElementProps) {
  const { element, className, attributes = {}, children, onClick, isLive } = props;
  const { color, size, customAttributes, contentPadding, gap } = element.attrs || {};

  const { refs, floatingStyles, y } = useFloating({
    strategy: isLive === false ? 'fixed' : 'absolute', // 'fixed' works better in the editor
    placement: 'bottom-end',
    transform: false,
  });

  // Attach both reference and position reference
  const setButtonRef = useCallback(
    (node: HTMLButtonElement | null) => {
      refs.setReference(node);
      if (node) {
        const navbarAncestor = node.closest<HTMLElement>('.navbar-list');
        if (navbarAncestor) {
          // Ensure it can act as a containing block
          if (getComputedStyle(navbarAncestor).position === 'static') {
            navbarAncestor.style.position = 'relative';
          }
          refs.setPositionReference(navbarAncestor);
        }
      }
    },
    [refs],
  );

  return (
    <>
      <button
        ref={setButtonRef}
        type="button"
        onClick={onClick}
        {...customAttributes}
        {...attributes}
        className={classNames(styles.navbarMenuBurgerV2, className, customAttributes?.className)}
        style={
          {
            '--text-color': computeColor(color ?? NAVBAR_MENU_BURGER_DEFAULTS_V2.color),
          } as CSSProperties
        }
      >
        <List size={size || NAVBAR_MENU_BURGER_DEFAULTS_V2.size} weight="bold" className={v2Styles.openIconV2} />
        <X size={size || NAVBAR_MENU_BURGER_DEFAULTS_V2.size} weight="bold" className={v2Styles.closeIconV2} />
      </button>

      <div
        ref={refs.setFloating}
        style={
          {
            ...floatingStyles,
            top: `${y}px`,
            left: '0px',
            '--content-gap': gap,
            '--content-padding': contentPadding,
          } as CSSProperties
        }
      >
        {children}
      </div>
    </>
  );
}
